import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { dashboardAPI } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

const eur = (v) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v || 0);
const CHANNEL = { whatsapp: "WhatsApp", website: "Sito Web", tiktok_shop: "TikTok Shop" };

const Tile = ({ label, value, sub, to, testid, accent }) => {
  const body = (
    <div className={`h-full rounded-xl border p-4 transition-colors ${accent ? "bg-[#C9A227] border-[#C9A227] text-white" : "bg-white border-gray-200 hover:border-[#C9A227]"}`}>
      <div className="flex items-center justify-between">
        <p className={`text-[11px] uppercase tracking-widest font-semibold ${accent ? "text-white/90" : "text-gray-500"}`}>{label}</p>
        {to && <ArrowUpRight className="w-4 h-4 opacity-60" />}
      </div>
      <p className="text-2xl font-bold mt-1 tabular-nums" data-testid={testid}>{value}</p>
      {sub && <p className={`text-xs mt-0.5 ${accent ? "text-white/80" : "text-gray-400"}`}>{sub}</p>}
    </div>
  );
  return to ? <Link to={to} className="block">{body}</Link> : body;
};

export const MoneyOverview = () => {
  const [s, setS] = useState(null);
  useEffect(() => { dashboardAPI.getStats().then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  return (
    <section className="space-y-3" data-testid="money-overview">
      <h2 className="text-lg font-serif text-gray-900">Incassi e guadagni</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <Tile label="Oggi" value={eur(s.today_revenue)} sub={`${s.today_sales_count || 0} ordini`} to="/fatturato?period=today" testid="money-today" />
        <Tile label="Settimana" value={eur(s.weekly_revenue)} to="/fatturato?period=week" testid="money-week" />
        <Tile label="Mese" value={eur(s.monthly_revenue)} to="/fatturato?period=month" testid="money-month" />
        <Tile label="Totale da Marzo" value={eur(s.total_revenue)} accent testid="money-total" />
      </div>
      {s.channel_breakdown && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {Object.entries(s.channel_breakdown).map(([ch, d]) => (
            <Tile key={ch} label={`${CHANNEL[ch] || ch} · 30 giorni`} value={eur(d.revenue)} testid={`money-channel-${ch}`} />
          ))}
        </div>
      )}
    </section>
  );
};
